/**
 * Accordion all modules
 */
export * from './accordion';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-navigations/src/accordion/index.js
// module id = 1868
// module chunks = 0